import { render, staticRenderFns } from "./Tipos_contratoFormulario.vue?vue&type=template&id=627a87bc&"
import script from "./Tipos_contratoFormulario.vue?vue&type=script&lang=ts&"
export * from "./Tipos_contratoFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports